export default "__VITE_ASSET__f311f7c7__"